import { useToastStore } from '../stores/useToastStore';
import { ToastType } from '../components/Toast';

export const useToast = () => {
  const { showToast, removeToast, clearAllToasts } = useToastStore();

  const toast = {
    success: (title: string, message?: string, duration?: number) => {
      showToast({ type: 'success', title, message, duration });
    },
    error: (title: string, message?: string, duration?: number) => {
      showToast({ type: 'error', title, message, duration });
    },
    warning: (title: string, message?: string, duration?: number) => {
      showToast({ type: 'warning', title, message, duration });
    },
    info: (title: string, message?: string, duration?: number) => {
      showToast({ type: 'info', title, message, duration });
    },
    custom: (type: ToastType, title: string, message?: string, duration?: number) => {
      showToast({ type, title, message, duration });
    },
    remove: removeToast,
    clearAll: clearAllToasts,
  };

  return toast;
};
